import React from "react";
import { motion } from "framer-motion";

const Loader: React.FC = () => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-white">
      <motion.div
        animate={{ rotate: 360 }}
        transition={{
          duration: 1.2,
          ease: "linear",
          repeat: Infinity,
        }}
        className="w-20 h-20"
      >
        <img
          src="/fleeby-logo (1).png"
          alt="Fleeby"
          className="w-full h-full object-contain"
        />
      </motion.div>
    </div>
  );
};

export default Loader;
